module.exports = __webpack_public_path__ + "img/maker_kale.134353ae.jpg";